import React, { FC, useEffect, useState } from 'react';
import { DetailsProaPresenter } from '@presenters/screens/details-proa.presenter';
import AEAGrid from '../../../ui/aea-grid/aea-grid';
import styles from './detail-proa.module.scss';

const DetailsProa: FC<any> = () => {

    const [dataColumns, setDataColumns] = useState(null);
    const [dataSource, setDataSource] = useState([])
    const [yearsRange, setYearsRange] = useState([])
    const [columnsAux, setcolumnsAux] = useState(null)
    const [done, setDone] = useState(false)
    const [fields, setFieldsColumns] = useState(null);
    
    const presenter = new DetailsProaPresenter({
        state:{
            dataColumns,
            dataSource: dataSource,
            setDataColumns:setDataColumns,
            setDataSource:setDataSource,
            setYearsRange:setYearsRange,
            setFieldsColumns
        }
    });

    const [options, setOptions] = useState(presenter.options);

    useEffect(() => {        
        if(presenter.currentLang && presenter.currentLabels && !done){
            setDone(true)
            presenter.initReport();
        }
    }, [presenter.currentLang, presenter.currentLabels]);

    const changeRange = (min: number, max: number, columns:any) => {
        let newColumns = presenter.changeRange(min, max, columns)
        setcolumnsAux(newColumns)
    }
    useEffect(() => {        
        let optionsAux = presenter.options
        optionsAux.columns = fields ? fields : []
        setOptions(optionsAux)
    }, [fields]);

    return (
        <div>    
            <div className={styles.yearsRange}>{presenter.currentLabels.get("RangoAñosDetalle")}</div>
            <AEAGrid
                currentLabels={presenter.currentLabels}
                columnsAux={columnsAux}
                yearsRange={yearsRange}
                changeRange={changeRange}
                dataGridOptions={options}>
            </AEAGrid>
        </div>
    )
}

export default DetailsProa;